<template>
  <div>
    <h4>Please select a decider node.</h4>
    <div>
      <v-treeview
        @update:active="getActiveValue"
        :key="treeViewKey"
        v-model="selectedNodes"
        value="values"
        :selection-type="selectionType"
        :active.sync="activeNodes"
        return-object
        :items="[treeViewRecord]"
        :open="openIds"
        activatable
        item-key="_id"
        item-text="name"
        class="treeClass"
        dense
      ></v-treeview>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    selectedRecord: Object,
    decidernode: String,
  },
  components: {},
  computed: {
    ...mapActions([
      "updateRecordParentIdAndChildCount",
      "openNewTab",
      "getRecordItemOnDemand",
    ]),
    ...mapGetters({
      treeViewRecord: "getActiveRecord",
    }),
    openIds() {
      return [this.treeViewRecord];
    },
  },
  created() {
    if (this.decidernode) {
      this.$store
        .dispatch("getRecordItemOnDemand", {
          recorditemid: this.decidernode,
          recordid: this.selectedRecord._id,
        })
        .then((record) => {
          this.activeNodes.push(record);
        });
    }
  },
  data() {
    return {
      treeViewKey: 0,
      selectedNodes: [],
      selectionType: "leaf",
      isSelectedable: false,
      activeNodes: [],
      values: [],
    };
  },
  methods: {
    getActiveValue(value) {
      if (value.length) {
        this.$emit("setdecidernodeid", value[0]._id);
      }
    },
  },
};
</script>

<style></style>
